import { render } from "./OutlaysCategories.vue?vue&type=template&id=f468e1fe"
import script from "./OutlaysCategories.vue?vue&type=script&lang=js"
export * from "./OutlaysCategories.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__